module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8997b5c23c84a4182883356bf17aae34.png";